/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeadSOffenderRecord } from './LeadSOffenderRecord';
import {
    LeadSOffenderRecordFromJSON,
    LeadSOffenderRecordFromJSONTyped,
    LeadSOffenderRecordToJSON,
    LeadSOffenderRecordToJSONTyped,
} from './LeadSOffenderRecord';

/**
 * 
 * @export
 * @interface FindSOffenderRecordsForLead200Response
 */
export interface FindSOffenderRecordsForLead200Response {
    /**
     * 
     */
    data?: Array<LeadSOffenderRecord>;
}

/**
 * Check if a given object implements the FindSOffenderRecordsForLead200Response interface.
 */
export function instanceOfFindSOffenderRecordsForLead200Response(value: object): value is FindSOffenderRecordsForLead200Response {
    return true;
}

export function FindSOffenderRecordsForLead200ResponseFromJSON(json: any): FindSOffenderRecordsForLead200Response {
    return FindSOffenderRecordsForLead200ResponseFromJSONTyped(json, false);
}

export function FindSOffenderRecordsForLead200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindSOffenderRecordsForLead200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(LeadSOffenderRecordFromJSON)),
    };
}

export function FindSOffenderRecordsForLead200ResponseToJSON(json: any): FindSOffenderRecordsForLead200Response {
    return FindSOffenderRecordsForLead200ResponseToJSONTyped(json, false);
}

export function FindSOffenderRecordsForLead200ResponseToJSONTyped(value?: FindSOffenderRecordsForLead200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(LeadSOffenderRecordToJSON)),
    };
}

